export default "__VITE_ASSET__B0$bEV2M__"